
/**
 * 해시태그 기본 정보
 */
export type HashtagResponseBasicInfo = {
  tag: string;
};
